import { cloneArray } from 'tools/array'

export const status = { // used
  AVAILABLE: 0,
  UNAVAILABLE: 1
}

// calculate 'selectedQuantity', 'totalSubprice' of options
// also, add 'quantity' field to the sub-variant objects
const calculateSubPrice = (item, form = {}, subItemVariantsKey) => {
  // need to cloneArray to prevent mutation on the original option object passed in from the argument
  const sorted = cloneArray(item[subItemVariantsKey]).sort((a, b) => {
    const aPriceDiff = a.price - a.priceUnderMinimumSelection
    const bPriceDiff = b.price - b.priceUnderMinimumSelection
    return aPriceDiff > bPriceDiff ? 1 : (aPriceDiff === bPriceDiff ? 0 : -1)
  })

  let sum = 0

  // add 'selectedQuantity' property to option
  item.selectedQuantity = sorted.reduce((acc, variant) => {
    if (form[item.id] && form[item.id][variant.id] !== undefined) {
      variant.quantity = form[item.id][variant.id] || 0 // add 'quantity' property to sub-variant
      const next = acc + variant.quantity
      if (acc >= item.minimumQuantity) {
        sum += (variant.price * variant.quantity)
      } else if (next <= item.minimumQuantity) {
        sum += (variant.priceUnderMinimumSelection * variant.quantity)
      } else {
        const withMinPrice = item.minimumQuantity - acc
        const withNormalPrice = (variant.quantity - withMinPrice)
        sum += (variant.priceUnderMinimumSelection * withMinPrice) + (variant.price * withNormalPrice)
      }
      return next
    }
    return acc
  }, 0)
  item.totalSubPrice = sum // add 'totalSubPrice' property to option
  return sum
}

// calculate total price of a product
// set 'selected' field of the selected variant to true
export const calculatePrice = (product, form, subItemVariantsKey) => {
  // find selected variant from form, first variant is selected by default
  const selectedVariant = product.variants ? product.variants.reduce((acc, variant) => {
    variant.selected = variant.id === form.selectedVariant // set 'selected' property to variant object
    if (variant.selected) return variant
    return acc
  }, false) || product.variants[0] : null

  // return 0 if there's no selected variant
  if (!selectedVariant) return 0

  selectedVariant.selected = true // set 'selected' property to variant object

  // add selected variant price to total price
  let total = selectedVariant.price || 0

  // calculate and add total sub price of selected variant's options to total price
  total += selectedVariant.subitems ? selectedVariant.subitems.reduce((acc, item) => acc + calculateSubPrice(item, form.subitems, subItemVariantsKey), 0) : 0

  // calculate and add total sub price of options to total price
  total += product.subitems ? product.subitems.reduce((acc, item) => acc + calculateSubPrice(item, form.subitems, subItemVariantsKey), 0) : 0

  return total
}

export const findItemFromMenu = ({ menu = [], id } = {}) => {
  let item
  if (id && menu) {
    menu.find(cat => {
      const result = cat.items.find(catItem => catItem.id === id)
      if (result) {
        item = result
      }
      return result
    })
  }
  return item
}

export const getFirstItemInMenu = ({ menu = [] } = {}) => {
  let item
  let index = 0

  while (index < menu.length) {
    const category = menu[index]
    if (category.items.length) {
      item = category.items[0]
      break
    }
    index += 1
  }
  return item
}

export const getSelectedVariantInfo = (variants, selectedVariantId) => {
  const { selectedVariant, minVariantPrice } = variants.reduce((acc, variant) => {
    acc.minVariantPrice = Math.min(variant.price, acc.minVariantPrice)
    if (variant.id === selectedVariantId) {
      acc.selectedVariant = variant
    }
    return acc
  }, { minVariantPrice: variants[0].price, selectedVariant: {} })

  const selectedVarPriceDiff = selectedVariant.price - minVariantPrice

  return { selectedVariant, minVariantPrice, selectedVarPriceDiff }
}

const getOptionsMinimumQuantityFromSubItems = (subitems) => (subitems || []).reduce((obj, subitem) => ({ [subitem.id]: subitem.minimumQuantity, ...obj }), {})

export const getOptionsMinimumQuantity = ({ product, selectedVariant }) => {
  const variant = product.variants.find(v => v.id === selectedVariant) || product.variants[0]
  const fromVariant = getOptionsMinimumQuantityFromSubItems(variant.subitems)
  const fromSubitems = getOptionsMinimumQuantityFromSubItems(product.subitems)
  return { ...fromVariant, ...fromSubitems }
}
